export default __webpack_public_path__ + "static/media/greeting1.38e96255.svg";